import {
  selectEditingCollection,
  setSelectedMenu,
  setSelectedMenuId,
} from "../../redux/features/appData";
import "./AskedQuestionsZero.css";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { MENUS } from "../config/menus";
import { useSelector } from "react-redux";
import { HelpCircle, BarChart3, Star, AlertTriangle } from "lucide-react";

type AskedQuestionsZeroProps = {
  variant?: "questions" | "categories" | "ratings" | "escalations";
};

export const AskedQuestionsZero = ({ variant = "questions" }: AskedQuestionsZeroProps) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const currentCollection = useSelector(selectEditingCollection);

  const getIcon = () => {
    switch (variant) {
      case "categories":
        return <BarChart3 size={48} />;
      case "ratings":
        return <Star size={48} />;
      case "escalations":
        return <AlertTriangle size={48} />;
      default:
        return <HelpCircle size={48} />;
    }
  };

  const getTitle = () => {
    switch (variant) {
      case "categories":
        return "No categories yet";
      case "ratings":
        return "No ratings yet";
      case "escalations":
        return "No escalations yet";
      default:
        return "No questions yet";
    }
  };

  const getDescription = () => {
    switch (variant) {
      case "categories":
        return "Questions will appear here once they've been categorized.";
      case "ratings":
        return "Ratings will appear here once questions have been rated.";
      case "escalations":
        return "Escalations will appear here when questions require escalation.";
      default:
        return "Start asking questions to see them here.";
    }
  };

  return (
    <div className="asked-questions-zero">
      <div className="asked-questions-zero-content">
        {getIcon()}
        <h3>{getTitle()}</h3>
        <p>{getDescription()}</p>
      </div>
    </div>
  );
};
